import { render } from "./AttendeeViewList.vue?vue&type=template&id=db54640c&scoped=true"
import script from "./AttendeeViewList.vue?vue&type=script&lang=js"
export * from "./AttendeeViewList.vue?vue&type=script&lang=js"

import "./AttendeeViewList.vue?vue&type=style&index=0&id=db54640c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db54640c"]])

export default __exports__